<template>
    <div class="home">
        <div v-show="isMask" class="mask"></div>
        <div class="dialog-top" style="height:50px">
            <div class="left" style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>活动地点</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="foodStreet">
                        <el-input   style="width: 270px;" v-model="searchForm.foodStreet" placeholder="请输入活动地点" size="small"  clearable>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="dialog-top" style="height:50px">
            <div class="left" style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>城市</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="areaCode">
                        <el-select v-model="searchForm.areaCode" placeholder="请选择城市" size="small" style="width: 270px;" @change="changeArea(searchForm.areaCode)" clearable>
                            <el-option v-for="(item) in areaCodearr" :key="item.orgCode" :label="item.orgName.split('|')[0]" :value="item.orgCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="dialog-top" style="height:50px">
            <div class="left" style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>活动时间</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="timeList">
                        <el-date-picker
                        @change="timeChange(searchForm.timeList)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="searchForm.timeList"
                        :picker-options="pickerOptions(searchList)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        :clearable="false"
                        :default-value="defauleTime"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="dialog-top" >
            <div class="left"  style="width: 88px;">
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>地址</span>
            </div>
            <div class="right">
                <el-form  :model="searchForm" ref="searchForm" class="searchForm">

                    <el-form-item  prop="saleName" class="item" >
                        <el-cascader
                        style="width: 270px;"
                        size="small"
                        clearable
                        v-model="searchForm.area"
                        :options="areaOptions"
                        :props="{ expandTrigger: 'hover' }"
                        @change="handleChange"></el-cascader>
                    </el-form-item>

                    <el-form-item class="item"  prop="saleName">
                        <el-input style="width:270px" v-model="searchForm.address" placeholder="输入详细地址" size="small" clearable>
                        </el-input>
                    </el-form-item>         
                </el-form>
            </div>
        </div>
        <!-- <div class="dialog-top" style="height:50px">
            <div class="left" style="width: 88px;">
                <span>百威联系人</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="bwContactPerson">
                        <el-input style="width: 270px;" v-model="searchForm.bwContactPerson" placeholder="请输入百威联系人" size="small"  clearable>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div> -->
        <div class="dialog-btn">
            <div class="btn-left" @click="closeDialog" >取消</div>
            <div class="btn-right" @click= 'clickOk' v-if="searchList.needSpr == '1'">确定</div>
            <DialogPop
            v-else
            class="btn-right"
            @confirm="clickOk()"
            :modal="false"
            isType="0"
            btnText="确定"
            centerText="是否确定替换？"
            @open='openBtn'
            @closeOpen="closeOpen"
            >
            </DialogPop>
        </div>
        <div class="dialog-close" @click="closeDialog()">
            <i class="el-icon-close" style="font-size: 28px;"></i>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import {regionData,CodeToText,TextToCode} from 'element-china-area-data'
    import gameplanApi from '../../../api/gameplan';
    import DialogPop from './dialog-pop.vue'
    export default {
      name: 'returnChange-empty-point',
      props: {
        options:{type:Object,default:()=>{}},
        searchList:{type:Object,default:()=>{}},
      },
      components: {
        DialogPop
      },
      data () {
        return {
            tableData: [],
            searchForm: {
                foodStreet:'',// 食街
                address:'',
                area:[], //省市区
                areaCode:'',
                bwContactPerson:'',
                areaName:'',
                timeList:[]
            },
            themeDetailId: '', 
            multipleSelection:[],
            selectOptions:[],
            pocRelateType: '',
            areaOptions:regionData,
            addtions:{},
            pocAddress:'',
            allArea:'',
            areaCodearr:[],
            isMask: false,
            defauleTime:'',
            pickerOptions(row = {}) {
                return{
                    disabledDate (time) {
                        // return time.getTime() < Date.now() - 8.64e7
                        let themeStartTime = new Date(row.themeStartTime.split('-').join('/')).getTime()
                        let themeEndTime = new Date(row.themeEndTime.split('-').join('/')).getTime()
                        let timeNo = row.timeNo
                        if (timeNo == themeStartTime) {
                            return time.getTime() > themeEndTime ||  time.getTime() < themeStartTime
                        } else {
                            return time.getTime() < timeNo  + 8.64e7 ||  time.getTime() > themeEndTime ||  time.getTime() < themeStartTime
                        }
                    }
                }
            },
        }
      },
      computed: {
        ...mapGetters(['userInfo']),   
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.getQueryarea()
            console.log(this.searchList,'售点----searchList')
            let min = Math.min(...this.searchList.reviseObj.timeList.map(item => new Date(item)));
            // console.log(min,'min-date1');
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            // let  blockAddress = "北京市/市辖区/西城区/999999".split('/')
            let  blockAddress = this.searchList.reviseObj.blockAddress.split('/')
            let arr1 = TextToCode[blockAddress[0]].code
            let arr2 = TextToCode[blockAddress[0]][blockAddress[1]].code
            let arr3 = TextToCode[blockAddress[0]][blockAddress[1]][blockAddress[2]].code
            this.searchForm.area.push(arr1,arr2,arr3)
            if ( this.searchForm.area.length > 0) {
                this.handleChange(this.searchForm.area)
            }
            this.searchForm.address =  blockAddress[3]
            this.searchForm.foodStreet =  this.searchList.reviseObj.foodStreet
            this.searchForm.areaCode = this.searchList.reviseObj.areaCode
            this.searchForm.bwContactPerson = this.searchList.reviseObj.bwContactPerson
            this.searchForm.areaName = this.searchList.reviseObj.areaName
            this.searchForm.timeList = this.searchList.reviseObj.timeList
            this.pocRelateType = this.searchList.pocRelateType
            this.themeDetailId = this.searchList.themeDetailId
        },
        openBtn () {
        this.isMask = true
        },
        closeOpen () {
        this.isMask = false
        },
        timeChange (timeItem){
            // console.log(timeItem,'timeItem');
            if (this.searchList.needTransitions == 0) {
                if (this.searchList.perExecDays) {
                    if (this.searchForm.timeList.length  !== this.searchList.perExecDays) {
                    this.$message.error(`选择天数与配置天数不符,您选择 ${this.searchForm.timeList.length}天，应选择 ${this.searchList.perExecDays}天`)
                    return
                }
                } else {
                    this.$message.warning('配置天数未返回')
                    return
                }
            }
        },
        closeDialog () {
            this.$emit('closeMask')
        },
        async getQueryarea () {
            let params = {'regionCode':this.searchList.regionCode}
           let res = await gameplanApi.getQueryarea(params)
           if (res.data.resultCode == '0') {
            this.areaCodearr = res.data.resultData.regionList
            }
        },
        clickOk () {
            if (this.searchForm.foodStreet == '' ) {
                this.$message.warning('活动地点未添加')
                return
            }
            if (this.searchForm.address == '' || this.searchForm.area == '') {
                this.$message.warning('地址未添加')
                return
            }
            if (this.searchForm.areaCode == '') {
                this.$message.warning('城市未添加')
                return
            }
            if (this.searchForm.timeList == null || this.searchForm.timeList.length == 0) {
                this.$message.warning('活动时间未添加')
                return
            }
            // if (this.searchForm.foodStreet == '' || this.searchForm.address == '' || this.searchForm.area == '' || this.searchForm.areaCode == '') {
            //     this.$message.warning('信息添加不全，不能进行确认操作')
            //     return
            // }
            if (this.searchList.needTransitions == 0) {
                if (this.searchList.perExecDays) {
                    if (this.searchForm.timeList.length  !== this.searchList.perExecDays) {
                    this.$message.error(`选择天数与配置天数不符,您选择 ${this.searchForm.timeList.length}天，应选择 ${this.searchList.perExecDays}天`)
                    return
                }
                } else {
                    this.$message.warning('配置天数未返回')
                    return
                }
            }
            this.pocAddress =  this.allArea + this.searchForm.address
            let arr = [{
                'block_name':this.searchForm.foodStreet,
                'pocAddress': this.pocAddress,
                'areaCode':this.searchForm.areaCode,
                'bwContactPerson':this.searchForm.bwContactPerson,
                'areaName':this.searchForm.areaName,
                'buName':this.userInfo.buName,
                'regionName':this.userInfo.regionName,
                'timeList':this.searchForm.timeList,
                'blockAddress':this.allArea
            }]
            // console.log(arr,'arr');
            this.$emit('handleEmptyChange',arr)
            this.$emit('closeMask')
        },
        handleChange (value) {
            let name = ''
            this.searchForm.area.map(item => name += CodeToText[item] + '/')
            this.allArea =  name
        },
        changeArea (val) {
            if (val) {
                for (let item of this.areaCodearr) {
                    if (item.orgCode == val) {
                        this.searchForm.areaName = item.orgName.split('|')[0]
                    }                 
                }              
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .home {
        position: relative;
        .mask{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.5) ;
            z-index: 3;
        }
        .dialog-top {
            display: flex;
            color: #101010;
            .left {
                width: 140px;
                line-height: 25px;
                font-size: 16px;
                text-align: left;
                font-weight: bold;
                margin-top: 5px;
            }
            .right {
                .searchForm {
                    width: 100%;
                    .item {
                        // width: 140px;
                        width: 170px;
                        line-height: 50px;
                        margin: 0 10px;
                    }
                }
            }
        }
        .dialog-btn {
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content:flex-end;
            .btn-left {
                width: 86px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                margin-right: 10px;
                cursor: pointer;
                height: 30px;
                line-height: 30px;
            }
            .btn-right {
                width: 86px;
                text-align: center;
                background-color: #cd1231;
                color: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
                height: 30px;
                line-height: 30px;
            }
        }
        .dialog-close {
            width: 30px;
            height: 30px;
            position: absolute;
            top: -10px;
            right: -10px;
            cursor: pointer;
        }
    }
</style>